import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ModoDeVenda} from '../../wizard-state.model';

interface OpcaoModoVenda {
  id: ModoDeVenda;
  icone: string;
  titulo: string;
  descricao: string;
}

@Component({
  selector: 'app-step-modo-venda',
  templateUrl: './step-modo-venda.component.html',
  styleUrls: ['./step-modo-venda.component.scss']
})
export class StepModoVendaComponent implements OnInit {
  @Input() modosAtuais: ModoDeVenda[] = [];
  @Output() onConcluido = new EventEmitter<ModoDeVenda[]>();
  @Output() onVoltar = new EventEmitter<void>();

  modosSelecionados: Set<ModoDeVenda> = new Set();
  erroValidacao: string | null = null;

  opcoes: OpcaoModoVenda[] = [
    {
      id: 'delivery',
      icone: 'fe-truck',
      titulo: 'Delivery',
      descricao: 'Entregas no endereço do cliente'
    },
    {
      id: 'retirada',
      icone: 'fe-shopping-bag',
      titulo: 'Retirada no local',
      descricao: 'Cliente retira o pedido na loja'
    },
    {
      id: 'mesa',
      icone: 'fe-grid',
      titulo: 'Mesa / QR Code',
      descricao: 'Pedidos para consumo no local'
    },
    {
      id: 'catalogo',
      icone: 'fe-eye',
      titulo: 'Apenas catálogo',
      descricao: 'Exibir produtos sem pedido online'
    }
  ];

  ngOnInit() {
    this.modosSelecionados = new Set(this.modosAtuais);
  }

  toggle(modo: ModoDeVenda) {
    if (this.modosSelecionados.has(modo)) {
      this.modosSelecionados.delete(modo);
    } else {
      this.modosSelecionados.add(modo);
    }
  }

  estaSelecionado(modo: ModoDeVenda): boolean {
    return this.modosSelecionados.has(modo);
  }

  podeAvancar(): boolean {
    return this.modosSelecionados.size > 0;
  }

  avancar() {
    if (this.modosSelecionados.size === 0) {
      this.erroValidacao = 'Selecione ao menos um modo de venda.';
      return;
    }
    this.erroValidacao = null;
    this.onConcluido.emit(Array.from(this.modosSelecionados));
  }

  voltar() {
    this.onVoltar.emit();
  }
}
